export default function MaterialIcon ({ name, className = '', filled = false, size, title, ...props }) {
  const style = size ? { fontSize: size, ...props.style } : props.style
  const classes = ['material-symbols-outlined', filled ? 'material-symbols-filled' : '', className].filter(Boolean).join(' ')

  return (
    <span className={classes} aria-hidden={title ? undefined : 'true'} title={title} style={style} {...props}>
      {name}
    </span>
  )
}
